import { cva } from 'class-variance-authority';

export const cvaRoot = cva(['PageTitle-cvaRoot', 'm-0 not-last:mb-2.4 sm:not-last:mb-4.8', 'text-h1 font-secondary']);

export const cvaSup = cva([
  'PageTitle-cvaSup',
  'inline-block ',
  '-top-0.5 sm:top-0',
  'py-0.4 px-0.6 ml-0.8',
  'align-top font-base text-bodyXS sm:text-bodyM text-cBlack text-opacity-[0.64]',
  'bg-cLightGrey',
  'rounded-[0.8rem]',
]);
